import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionDimensionDetail extends BaseModelAPI {
	static entity = 'productionqualityinspectiondimensiondetail';
	static entityName = 'productionqualityinspectiondimensiondetail';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.productionQualityInspectionDimensionId = '';
		this.productionQualityInspectionDimension = {};
		this.partId = '';
		this.part = {};
		this.partName = '';
		this.customer = '';
		this.isChecked = false;
		this.attachmentId = '';
		this.attachment = {};
		this.remark = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async deleteDataByParentId(this_, id) {
		return this_.$http.delete(`${this.entityName}/deletedatabyparentid/${id}`).then(result => {
			return result.data
		}).catch(function (error) {
			this_.$store.dispatch('addErrorMessageGlobal', error);
			return false;
			throw error;
		});
	}

	static async CheckPartFromWoProcess(this_, id, partId) {
		return this_.$http.put(`${this.entityName}/checkpartfromwoprocess/${id}?partId=${partId}`)
			.then(result => {
				return result.data
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				return null;
				throw error;
			});
	}
}